import { Typography } from "antd";
import PolicyHeader from "../components/PolicyHeader";
import PolicyNav from "../components/PolicyNav";
import informationSecurityContent from "../data/informationSecurityContent";
import { parseMarkdownBold } from "../helpers/tranformers";

const { Title, Paragraph } = Typography;

const renderBlock = (block, index) => {
  if (block.type === "paragraph") {
    return (
      <Paragraph key={index}>
        {block.children.map((child, i) => (
          <span key={i}>{parseMarkdownBold(child.text)}</span>
        ))}
      </Paragraph>
    );
  }

  if (block.type === "list") {
    return (
      <ul key={index} style={{ paddingLeft: "2.5rem" }}>
        {block.children.map((item, idx) => (
          <li key={idx}>
            {item.children.map((child, i) => (
              <span key={i}>{child.text}</span>
            ))}
          </li>
        ))}
      </ul>
    );
  }

  return null;
};

const InformationSecurity = () => {
  const content = informationSecurityContent;

  return (
    <div className="policy-background wave-container">
      <PolicyHeader heading={content.MainHeading} />

      <div className="policy-main-div">
        <PolicyNav active="security" />

        {content.TextSection.map((section, index) => (
          <div key={section.id}>
            <Title level={5}>
              {index === 0 ? section.Title : `${index}. ${section.Title}`}
            </Title>
            {section.Content.map(renderBlock)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InformationSecurity;
